/**
 * 请求基础路径
 * 开发环境: dev_url, 生产环境: pro_url
*/
module.exports = {
  // dev_url: "http://192.168.2.88:8088/", // 许兔
  // dev_url: 'http://192.168.2.26:8088/', // 徐哲
  // dev_url: "http://192.168.2.8:8088/", // 测试环境
  // dev_url: "http://dev.kzmooc.com:8088/", // 测试环境
  dev_url: "https://cug-wenhua.kzmooc.cn/", // 正式环境

  
  // pro_url: "http://192.168.2.88:8088/" // 许兔
  // pro_url: "http://192.168.2.26:8088/" // 徐哲
  // pro_url: "http://192.168.2.8:8088/", // 测试环境
  // pro_url: "http://dev.kzmooc.com:8088/", // 测试环境
  pro_url: "https://cug-wenhua.kzmooc.cn/", // 正式环境
}
